import React, { useState, useEffect, useRef } from 'react';
import { SessionUser } from '../services/horasService';

interface AvatarMenuProps {
  sessionUser: SessionUser;
  onLogout: () => void;
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({ sessionUser, onLogout }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const initials = sessionUser.isSuperAdmin
    ? 'NE'
    : sessionUser.subject
        .split(/[-_\s]/)
        .map((p) => p[0]?.toUpperCase() ?? '')
        .slice(0, 2)
        .join('');

  const displayName = sessionUser.isSuperAdmin ? 'Neos (Admin)' : sessionUser.subject;

  return (
    <div className="avatar-wrapper" ref={ref}>
      <button
        type="button"
        className="avatar-btn"
        onClick={() => setOpen((v) => !v)}
        aria-label="Menú de usuario"
        title={displayName}
      >
        <span className="avatar-initials">{initials}</span>
      </button>

      {open && (
        <div className="avatar-dropdown">
          <div className="avatar-dropdown-header">
            <span className="avatar-dropdown-initials">{initials}</span>
            <div>
              <div className="avatar-dropdown-name">{displayName}</div>
              <div className="avatar-dropdown-role">
                {sessionUser.isSuperAdmin ? 'Administrador' : 'Cliente'}
              </div>
            </div>
          </div>
          <hr className="avatar-divider" />
          <button
            type="button"
            className="avatar-logout-btn"
            onClick={() => { setOpen(false); onLogout(); }}
          >
            Cerrar sesión
          </button>
        </div>
      )}
    </div>
  );
};

export default AvatarMenu;
